import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/apps/frontend/src/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/apps/frontend/src/layouts/default.vue").then(m => m.default || m)),
  profile: defineAsyncComponent(() => import("/app/apps/frontend/src/layouts/profile.vue").then(m => m.default || m))
}